import { useStaticQuery, graphql } from "gatsby"

export const useBlogPosts = () => {
  const { strapi } = useStaticQuery(
    graphql`
      query BlogPosts {
        strapi {
          posts(where: { isPublished: true }
				sort: "publishedDate:desc") {
            ...postFields
          }
        }
      }
    `
  )
  return strapi.posts
}

export const PostFragment = graphql`
  fragment postFields on Strapi_Post {
    id
    slug
    title
    publishedDate
    category {
      ...categoryFields
    }
    featuredImage {
      formats
      url
      width
    }
    author {
      name
    }
  }
`
